import { v4 as uuid } from "uuid";

const { pintrk } = window;

export function enablePinterestTracking() {
  pintrk && pintrk("setconsent", true);
}

export function sendPinterestPageViewEvent() {
  pintrk &&
    pintrk("track", "pagevisit", {
      event_id: uuid(),
    });
}

export function sendPinterestAddToCartEvent(
  product_id: string,
  product_name: string,
  value: number,
  order_quantity: number,
  currency: string
) {
  pintrk &&
    pintrk("track", "addtocart", {
      event_id: uuid(),
      value,
      order_quantity,
      currency,
      line_items: [
        {
          product_id,
          product_name,
        },
      ],
    });
}
